import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { api_url } from "../helpers/apiHelpers";

const Contact = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const storeContact = async () => {
    try {
      const response = await fetch(`${api_url}/api/users/add-contact-data`, {
        method: "POST",
        body: JSON.stringify({
          name,
          officeName,
          mobile,
          email,
          subject,
          message,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();
      if (result.status === 201) {
        toast.success(result.message);
        setTimeout(() => {
          navigate("/");
        }, 2000); // Redirect after 2 seconds
      }
    } catch (error) {
      toast.error("Data not sent. Please try again.");
    }
  };
  return (
    <div>
      <Header />
      <main className="main">
        {/* Contact Section */}
        <section id="contact" className="contact section">
          {/* End Google Maps */}

          <div className="container mx-auto py-10">
          <div className="row">
          <div className="col-lg-8 m-auto">
            <div className="row">
              {/* Contact Info */}
              <div className="col-lg-6">
                <div className="p-4 shadow-lg rounded-md border-t-4 border-red-600 h-100">
                  <h3 className="text-2xl font-semibold mb-1 text-center">Get in touch</h3>
                  <p className="text-gray-700 mb-3 text-center">
                    Get in Touch with{" "}
                    <span className="text-green-600">digitalparag.com</span> –
                    Simplifying Your Paperwork Hassle-Free!
                  </p>

                  <div className="row">
                    <div className="col-lg-12 mb-2">
                      {/* Location Info */}
                      <div className="card p-3 w-100 text-center">
                        <div className="flex-shrink-0">
                          <i className="fa fa-location text-red-600 text-2xl"></i>
                        </div>
                        <div className="ml-4">
                          <h4 className="text-lg font-semibold text-red-600">
                            Location:
                          </h4>
                          <p className="text-gray-700">
                            N 7, CIDCO, chatrapati sambhajinagar 431003
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 mt-3">
                      {/* Email Info */}
                      <div className="card p-3 text-center w-100">
                        <div className="flex-shrink-0">
                          <i className="fa fa-envelope text-red-600 text-2xl"></i>
                        </div>
                        <div className="text-center">
                          <h4 className="text-lg font-semibold text-red-600">
                            Email:
                          </h4>
                          <p className="text-gray-700">contact@digitalparag.com</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 mt-3">
                      {/* Phone Info */}
                      <div className="card p-3 text-center w-100">
                        <div className="flex-shrink-0">
                          <i className="fa fa-phone text-red-600 text-2xl"></i>
                        </div>
                        <div className="">
                          <h4 className="text-lg font-semibold text-red-600">
                            Call:
                          </h4>
                          <p className="text-gray-700">
                            <Link to={"tel:8329107522"}> +91-8329107522</Link>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Form */}
              <div className="col-lg-6 ">
                <div className="p-8 bg-white shadow-lg rounded-md border-t-4 border-red-600">
                  <form >
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-3">
                      <div>
                        <input
                          type="text"
                          name="name"
                          id="name"
                          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-600"
                          placeholder="Your Name"
                          onChange={(e) => setName(e.target.value)}
                          required
                        />{" "}
                        <br />
                      </div>
                     
                    <div >
                      <input
                        type="text"
                        name="officeName"
                        id="officeName"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-600"
                        placeholder="Office Name"
                        required
                        onChange={(e) => setOfficeName(e.target.value)}
                      />
                    </div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-3">
                    <div>
                        <input
                          type="email"
                          name="email"
                          id="email"
                          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-600"
                          placeholder="Your Email"
                          required
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                    <div>
                      <input
                        type="text"
                        name="mobile"
                        id="mobile"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-600"
                        placeholder="Mobile Number"
                        required
                        onChange={(e) => setMobile(e.target.value)}
                      />
                    </div>
                    </div>
                    <div className="mb-3">
                      <input
                        type="text"
                        name="subject"
                        id="subject"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-600"
                        placeholder="Subject"
                        required
                        onChange={(e) => setSubject(e.target.value)}
                      />
                    </div>
                    <div className="mb-3">
                      <textarea
                        name="message"
                        id="message"
                        className="w-full h-32 px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-600"
                        placeholder="Message"
                        onChange={(e) => setMessage(e.target.value)}
                        required
                      ></textarea>
                    </div>
                    <div className="text-center">
                      <button
                      type="button"
                        onClick={storeContact}
                        className="bg-red-600 text-white py-3 px-8 rounded-full hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-600"
                      >
                        Send Message
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Contact;
